import { createStore } from "solid-js/store";
export const NUM_QUESTIONS = 10;
export const [storedDescription, updateStoredDescription] = createStore({
  description: "",
});
export const [storedQuestions, updateStoredQuestions] = createStore({
  questions: [],
});
export const [storedUserAnswers, updateStoredUserAnswers] = createStore({
  answers: Array.from({ length: NUM_QUESTIONS }, () => []),
});
export const [storedFeedbackArr, updateStoredFeedbackArr] = createStore({
  feedback: Array.from({ length: NUM_QUESTIONS }, () => []),
});
export const [storedGeneralFeedback, updateGeneralFeedback] = createStore({
  feedback: "",
});
export const [loadingState, setLoading] = createStore({ loading: false });
export const [STAR_TOTAL, updateStarRating] = createStore({ stars: 0 });
export const [idxAnswered, updateIdxAnswered] = createStore({
  answered: Array(NUM_QUESTIONS).fill("white"),
});
export const [activeQuestion, updateActiveQuestion] = createStore({
  q: ["#353535", ...Array(NUM_QUESTIONS - 1).fill("#242424")],
});
